import { render, staticRenderFns } from "./AppraiserFormResultStep.vue?vue&type=template&id=901f9bd6&"
import script from "./AppraiserFormResultStep.vue?vue&type=script&lang=ts&"
export * from "./AppraiserFormResultStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports